import { useLocation, useNavigate } from "react-router-dom";
import OffcanvasMenuBoxItem from "./OffcanvasMenuBoxItem";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setTheme, logoutUser } from "../../redux/actions";
import { handleLogout } from "../../config/axios";
import decryptData from "../../decrypt";
import { apiFetch } from '../../config/fetch';
import logService from "../../services/logging/logService";

interface MenuItem {
  name: string;
  image: string;
  page: { slug: string };
}

function OffcanvasMenu({ onClose, logoutUser, ...props }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [menu, setMenu] = useState<MenuItem[]>([]);
  const theme = localStorage.getItem("theme");

  const setTheme = (event: React.MouseEvent, value: string) => {
    event.preventDefault();
    const theme = value || "light";
    localStorage.setItem("theme", theme);
    props.setTheme({ theme });
  };

  const handleMenuClick = (slug, name) => {
    navigate(slug);
    
    // Log esplicito per la navigazione del menu
    try {
      logService.logNavigation(
        slug,
        `Navigazione da menu a: ${name || slug}`,
        { 
          title: name,
          path: slug,
          source: 'menu-click',
          hash: '',
          search: ''
        }
      );
      console.log(`Menu navigation logged: ${slug} (${name})`);
    } catch (e) {
      console.error('Error logging menu navigation:', e);
    }
    
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const handleLogoutClick = (e) => {
    e.preventDefault();
    handleLogout();
    logoutUser();
    if (typeof onClose === "function") {
      onClose();
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const request = await apiFetch(`/nodeapi/menu`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (request.status === 401 || request.status === 403) {
          handleLogout();
          return;
        }

        const response = await request.json();
        if (!request.ok) {
          throw new Error(response.errorMessage);
        }

        const decrypted = await decryptData(response.encryptedData, response.encryptedKey, response.iv);
        const menus: MenuItem[] = JSON.parse(decrypted);
        // Filtra Aggiornamento Dati
        const filteredMenu = menus.filter(
          (item: MenuItem) => item.name !== "Aggiornamento Dati"
        );
        setMenu(filteredMenu);
      } catch (e) {
        console.error(e);
      }
    })();
    const themeSaved = localStorage.getItem("theme");
    props.setTheme({ theme: themeSaved });
  }, []);

  // Riorganizza il menu per gestire l'elemento Documenti
  const regularItems = menu.filter(item => item.name !== "CUSTOM MENU");
  const documentiItem = menu.find(item => item.name === "CUSTOM MENU");

  return (
    <div className="flex flex-col w-full">

      {/* User Profile button */}
{/*       <div
        onClick={() => handleMenuClick("user-profile")}
        className="cursor-pointer border-b border-solid border-neutral-200 text-center py-7 px-6"
      >
        <span className="material-symbols-outlined text-2xl text-neutral-600 dark:text-neutral-400 mb-2">
          person
        </span>
        <span className="text-lg text-neutral-600 dark:text-neutral-400">Profilo Utente</span>
      </div> */}

      {/* Grid per elementi regolari */}
      <div className="grid grid-cols-2">
        {regularItems.map((m: MenuItem, i: number) => {
          const isLeftColumn = i % 2 === 0;
          const isLastRow = i >= regularItems.length - 2;
          
          return (
            <OffcanvasMenuBoxItem
              key={i}
              onClick={() => handleMenuClick(m.page.slug, m.name)}
              active={location.pathname === "/" && m.page.slug === "/" 
                ? true 
                : location.pathname.substring(1) === m.page.slug}
              className={`${!isLastRow ? 'border-b' : ''} ${isLeftColumn ? 'border-r' : ''}`}
              title={m.name}
              link={m.page.slug}
              icon={m.image}
            />
          );
        })}
      </div>

      

      {/* Elemento Documenti a larghezza piena */}
      {documentiItem && (
        <div className="w-full border-b">
          <OffcanvasMenuBoxItem
            onClick={() => handleMenuClick(documentiItem.page.slug, documentiItem.name)}
            active={location.pathname.substring(1) === documentiItem.page.slug}
            className="py-12"
            title={documentiItem.name}
            link={documentiItem.page.slug}
            icon={documentiItem.image}
            isDouble
          />
        </div>
      )}



      {/* Logout button */}
      <div
        onClick={handleLogoutClick}
        className="cursor-pointer border-b border-solid border-neutral-200 text-center py-7 px-6"
      >
        <span className="text-lg text-neutral-600 dark:text-neutral-400">Logout</span>
      </div>

      {/* Theme switcher */}
      <div className="grid grid-cols-2 py-2">
        <OffcanvasMenuBoxItem
          link=""
          onClick={(e) => {
            setTheme(e, "dark");
            onClose?.();
          }}
          active={theme === "dark"}
          className="border-r"
          title="Tema Scuro"
          icon="dark_mode"
        />
        <OffcanvasMenuBoxItem
          link=""
          onClick={(e) => {
            setTheme(e, "light");
            onClose?.();
          }}
          active={theme === "light"}
          className=""
          title="Tema Chiaro"
          icon="light_mode"
        />
      </div>
    </div>
  );
}

const mapStateToProps = ({ menu }) => {
  const { theme } = menu;
  return { theme };
};

export default connect(mapStateToProps, { setTheme, logoutUser })(OffcanvasMenu);